import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

function SEO({ lang, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title,
            preTitle
          }
        }
      }
    `
  )

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={site.siteMetadata.preTitle + ' %s - ' + site.siteMetadata.title}
      link={[
        {
          "rel": "icon",
          "href": "favicon.ico"
        }
      ]}
      meta={[
        {
          "name": "theme-color",
          "content": "#000000"
        },
        {
          "name": "og:image",
          "content": "og_image.jpg"
        },
        {
          "name": "og:title",
          "content": site.siteMetadata.preTitle + ` ${title} - ` + site.siteMetadata.title
        }
      ]}
    />
  )
}

export default SEO